import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import {
  Menu,
  AppBar,
  Toolbar,
  MenuItem,
  Typography,
  IconButton,
  withStyles,
} from '@material-ui/core'
import {
  AccountCircle,
} from '@material-ui/icons'

import { logout, editPassword } from '../actions/profile'
import { IS_ADMIN } from '../constant'
import ModalEditPassword from '../components/ModalEditPassword'
import { triggerResetPassword } from '../actions/market'


const styles = theme => ({
  root: {
    zIndex: 1,
    background: 'white',
    position: 'relative',
    color: theme.palette.common.black,
    boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.25)',
  },
  toolbar: {
    paddingLeft: 15,
    paddingRight: 15,
  },
  title: {
    flexGrow: 1,
  },
  burgerContainer: {
    marginRight: 16,
  },
  burger: {
    width: 20,
    height: 16,
    cursor: 'pointer',
    position: 'relative',
    transform: 'rotate(0deg)',
    transition: '.2s ease-in-out',

    '& > span': {
      left: 0,
      height: 2,
      opacity: 1,
      width: '100%',
      borderRaidus: 4,
      display: 'block',
      position: 'absolute',
      transform: 'rotate(0deg)',
      transition: '.15s ease-in-out',
      background: theme.palette.common.black,

      '&:nth-child(1)': {
        top: 0,
      },

      '&:nth-child(2)': {
        top: 8,
      },

      '&:nth-child(3)': {
        top: 16,
      },
    },
  },
  burgerOpened: {
    '& > span': {
      '&:nth-child(1)': {
        top: 8,
        transform: 'rotate(135deg)',
      },

      '&:nth-child(2)': {
        left: -60,
        opacity: 0,
      },

      '&:nth-child(3)': {
        top: 8,
        transform: 'rotate(-135deg)',
      },
    },
  },
})


class Header extends PureComponent {
  /* LIFECYCLE */

  state = {
    menuAnchor: null,
    modalOpened: false,
  }


  /* METHODS */

  handleLogout = () => {
    this.props.logout()
    this.handleCloseMenu()
  }

  handleOpenMenu = e => this.setState({ menuAnchor: e.currentTarget })

  handleCloseMenu = () => this.setState({ menuAnchor: null })

  handleOpenModal = () => this.setState({ modalOpened: true })

  handleCloseModal = () => this.setState({ modalOpened: false })

  handleChangePassword = (data) => {
    this.props.editPassword(data)
    this.handleCloseModal()
  }

  handleResetPassword = () => {
    this.props.triggerResetPassword(this.props.user.email)
    this.handleCloseMenu()
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      classes,
      drawerOpened,
      onToggleDrawer,
    } = this.props
    const {
      menuAnchor,
      modalOpened,
    } = this.state

    return (
      <AppBar position="static" color="primary" className={classes.root}>
        <Toolbar className={classes.toolbar}>
          {IS_ADMIN && (
            <IconButton
              color="inherit"
              aria-label="menu"
              onClick={onToggleDrawer}
              className={(classes.burgerContainer)}
            >
              <div
                className={classNames(classes.burger, {
                  [classes.burgerOpened]: drawerOpened,
                })}
              >
                <span />
                <span />
                <span />
              </div>
            </IconButton>
          )}

          <Typography variant="h5" className={classes.title}>Echo-chèques - {IS_ADMIN ? 'Administration' : 'Commerce'}</Typography>

          <div>
            <IconButton
              color="inherit"
              aria-haspopup="true"
              aria-controls="menu-appbar"
              onClick={this.handleOpenMenu}
              aria-label="Compte de l'utilisateur"
            >
              <AccountCircle />
            </IconButton>

            <Menu
              keepMounted
              id="menu-appbar"
              open={!!menuAnchor}
              anchorEl={menuAnchor}
              onClose={this.handleCloseMenu}
            >
              <MenuItem disabled={this.props.isLoading} onClick={this.handleResetPassword}>Changer mot de passe</MenuItem>
              <MenuItem disabled={this.props.isLoading} onClick={this.handleLogout}>Déconnexion</MenuItem>
            </Menu>
          </div>
        </Toolbar>

        <ModalEditPassword
          open={modalOpened}
          onClose={this.handleCloseModal}
          onSubmit={this.handleChangePassword}
        />
      </AppBar>
    )
  }
}


Header.propTypes = {
  user: PropTypes.object,
  drawerOpened: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  editPassword: PropTypes.func.isRequired,
  onToggleDrawer: PropTypes.func.isRequired,
  triggerResetPassword: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  user: state.app.user,
  isLoading: state.app.isLoading,
})


export default connect(mapStateToProps, {
  logout,
  editPassword,
  triggerResetPassword,
})(withStyles(styles)(Header))
